import Image from 'next/image';

const VALID = new Set(['nastaveni', 'sablony', 'automatizace', 'skoleni', 'rozesilky', 'audit', 'sms', 'konzultace']);

export default function ServiceIcon({ name, size = 20 }) {
  const icon = VALID.has(name) ? name : 'nastaveni';
  return (
    <Image
      src={`/icons/sluzby/${icon}.svg`}
      alt=""
      width={size}
      height={size}
      aria-hidden="true"
      unoptimized
    />
  );
}
